import { render, staticRenderFns } from "./days_in_transit.vue?vue&type=template&id=6e89b3ea"
import script from "./days_in_transit.vue?vue&type=script&lang=js"
export * from "./days_in_transit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports